<app-header></app-header>

<div class="page-wrapper">
  <app-sidenav></app-sidenav>
  <div [class.expanded]="!isSidebarExpanded" class="page-content-wrapper">
    <main [class.use-padding]="usePadding" >
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<app-inactivity-warning *ngIf="idleService.showWarningModal$ | async"></app-inactivity-warning>

<lib-chat *ngIf="authService.isAuthorized(PermissionsEnum.AiChat_Use)"></lib-chat>
